import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3dbb809e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/opter/repo/code/cloudsee-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dbb809e')) {
      api.createRecord('3dbb809e', component.options)
    } else {
      api.reload('3dbb809e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3dbb809e", function () {
      api.rerender('3dbb809e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/AreaSelector/index.vue"
export default component.exports